/**
 * Ruta /more — el menú móvil.
 *
 * Existe en la app original y es imprescindible: la barra inferior solo tiene
 * cinco huecos, así que Vendors, Expenses, Maintenance, Reports y Settings solo
 * son alcanzables desde aquí en pantallas pequeñas.
 */
import { Link } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import { MOBILE_SECONDARY, PageHeader } from '@/components/app-shell'
import { Card } from '@/components/ui/card'

export function MorePage() {
  return (
    <>
      <PageHeader title="More" subtitle="Todo lo demás en FleetOps" />
      <Card className="divide-y divide-border overflow-hidden">
        {MOBILE_SECONDARY.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="flex min-h-[60px] items-center gap-3 px-4 py-3 transition-colors hover:bg-muted"
          >
            <span className="grid size-9 shrink-0 place-items-center rounded-lg bg-primary-muted text-accent-foreground">
              <item.icon className="size-[18px]" aria-hidden />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-medium">{item.label}</span>
              <span className="block truncate text-xs text-muted-foreground">
                {item.description}
              </span>
            </span>
            <ChevronRight className="size-4 shrink-0 text-muted-foreground" aria-hidden />
          </Link>
        ))}
      </Card>
    </>
  )
}
